import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NonNullableFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { map } from 'rxjs';

@Component({
  selector: 'app-yes-or-no-accordion',
  templateUrl: './yes-or-no-accordion.component.html',
  styleUrl: './yes-or-no-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YesOrNoAccordionComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class YesOrNoAccordionComponent implements ControlValueAccessor {
  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  readonly valueControl = this.fb.control(false);

  readonly options$ = this.translate.stream(['GENERIC.YES', 'GENERIC.NO']).pipe(
    map((translations) => [
      {
        value: true,
        label: translations['GENERIC.YES'],
      },
      {
        value: false,
        label: translations['GENERIC.NO'],
      },
    ]),
  );

  constructor(
    private readonly fb: NonNullableFormBuilder,
    private readonly translate: TranslateService,
  ) {}

  set value(value: boolean) {
    this.valueControl.setValue(value);
  }

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onValueChange(event: DropdownChangeEvent): void {
    this.onChange(event.value);
    this.onTouched();
  }
}
